import { useEffect, useMemo, useState } from 'react';
import { Box, ButtonBase, Checkbox, FormControlLabel, makeStyles } from '@material-ui/core';
import _, { isArray } from 'lodash';
import Text from '../../../../components/Text';
import { AutoCompleteInput, AutoCompleteSelect } from '../../../../components';
import StyleInput from '../../../../components/StyleInput';
import { AddIcon, DeleteIcon, TriangleIcon } from '../../../../components/Icon';
import AddRemarks from '../../../../components/AddRemarks';
import { bedStatusAPI } from '../../../../apis';
import StyleButton from '../../../../components/StyleButton';
import bs_basic_cleansing from '../../../../static/images/bs_basic_cleansing.png';
import bs_terminal_disinfection from '../../../../static/images/bs_terminal_disinfection.png';
import { getUUID, useGetUserInfo } from '../../../../utils';

const remarkLimit = 60;

const AddServiceOrders = ({
  serviceList,
  setOrderService,
  defaultRemark,
  type = 'default',
  defaultCleaningCase = 'default',
}) => {
  const classes = useStyles();
  const [serviceMappingList, setServiceMappingList] = useState([]);
  const [serviceRemarkList, setServiceRemarkList] = useState([]);
  const [destinationList, setDestinationList] = useState([]);
  const defaultType = type === 'default';
  const userInfo = useGetUserInfo();

  const handleUpdateOrderService = (type, id) => (value) => {
    setOrderService((prev) =>
      prev.map((item) => ({
        ...item,
        [type]: item.id === id ? value : item[type],
      }))
    );
  };

  const handleDeleteOrderService = (id) => () => {
    setOrderService((prev) => prev.filter((item) => item.id !== id));
  };

  const handleAddRemark = (id) => (value) => {
    setOrderService((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          const newRemark = item.serviceRemark ? `${item.serviceRemark} ${value}` : value;
          return {
            ...item,
            serviceRemark: newRemark.slice(0, remarkLimit),
          };
        }

        return item;
      })
    );
  };

  const getWardServicesMappingList = async () => {
    try {
      const { result } = await bedStatusAPI.getWardServicesMappingList();
      setServiceMappingList(result);
    } catch (error) {
      console.log(error);
    }
  };

  const getServiceRemarkList = async () => {
    try {
      const { result } = await bedStatusAPI.getServiceOrderRemarkList({ status: 1 });
      if (isArray(result?.data) && result?.data.length > 0) {
        setServiceRemarkList(result?.data);
      }
    } catch (error) {}
  };

  const getDestinationListList = async () => {
    try {
      const { result } = await bedStatusAPI.getOrderLocationList({ hospitalCode: userInfo.hospCode });
      if (isArray(result?.ADSInfoDetails) && result?.ADSInfoDetails.length > 0) {
        const locationList = _.map(result?.ADSInfoDetails, (item) => ({
          text: item.locationDesc,
          value: item.locationCode,
        }));
        setDestinationList(locationList);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getWardServicesMappingList();
    getServiceRemarkList();
    getDestinationListList();
  }, []);

  const initLeftIcon = (data) => {
    switch (data.cleaning) {
      case 'TD':
        return () => <img className={classes.icon} src={bs_terminal_disinfection} alt="" />;
      case 'B':
        return () => <img className={classes.icon} src={bs_basic_cleansing} alt="" />;
      default:
        return () => <div />;
    }
  };

  const typeOption = useMemo(() => {
    const options = serviceMappingList
      .filter((item) => item.serviceType)
      .map((item) => ({
        text: item.serviceDesc,
        value: item.serviceType,
        serviceTypeDesc: item.serviceTypeDesc,
        leftIcon: initLeftIcon(item),
      }));

    return defaultType
      ? options
      : [
          {
            text: '',
            value: '',
          },
          ...options,
        ];
  }, [serviceMappingList, defaultType]);

  const renderServiceTypeOption = (option) => {
    const LeftIcon = option.leftIcon;

    return (
      <>
        {LeftIcon ? <LeftIcon /> : ''}
        <Box display="block" minWidth={0} overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
          {option.serviceTypeDesc && <span className={classes.serviceTypeDesc}>{`${option.serviceTypeDesc} - `}</span>}
          <span>{option.text}</span>
        </Box>
      </>
    );
  };

  const renderUrgentLabel = () => {
    return (
      <Box className={classes.urgentLabel}>
        <Text>Is Urgent</Text>
        <Box position="relative" display="inline-block" width="1.5rem" height="1.3rem">
          <TriangleIcon className={classes.triangleIcon} />
          <div className={classes.triangleText}>!</div>
        </Box>
      </Box>
    );
  };

  const defaultServiceType = useMemo(() => {
    if (type === 'discharge') {
      // return _.find(serviceMappingList, (item) => item.default === 1)?.serviceType ?? '';
      // const bedCleansingServiceType = _.find(serviceMappingList, (item) => item.cleaning === 'B')?.serviceType ?? '';
      const serviceTypeDefaultVal = _.find(serviceMappingList, (item) => item.default === 1)?.serviceType ?? '';
      switch (defaultCleaningCase) {
        case 'AIRBORNE_PRECAUTION':
        case 'DROPLET_PRECAUTION':
        case 'CONTACT_PRECAUTION':
        case 'MDRO':
        case 'COVID19':
          return (
            _.find(serviceMappingList, (item) => _.includes(item.cleaningCase, defaultCleaningCase))?.serviceType ??
            serviceTypeDefaultVal
          );
        case 'default':
          return '';
        default:
          return serviceTypeDefaultVal;
      }
    }
    return '';
    // const bedCleansingServiceType = _.find(serviceMappingList, (item) => item.cleaning === 'B')?.serviceType ?? '';
    // switch (defaultCleaningCase) {
    //   case 'AIRBORNE_PRECAUTION':
    //   case 'DROPLET_PRECAUTION':
    //   case 'CONTACT_PRECAUTION':
    //   case 'MDRO':
    //   case 'COVID19':
    //     return (
    //       _.find(serviceMappingList, (item) => item.cleaningCase === defaultCleaningCase)?.serviceType ??
    //       bedCleansingServiceType
    //     );
    //   case 'default':
    //     return '';
    //   default:
    //     return bedCleansingServiceType;
    // }
  }, [serviceMappingList, defaultCleaningCase, type]);

  useEffect(() => {
    if (defaultServiceType) {
      setOrderService((prev) =>
        prev.map((item) => ({
          ...item,
          serviceType: defaultServiceType,
        }))
      );
    }
  }, [defaultServiceType]);

  const handleAddOrderService = () => {
    setOrderService((prev) => [
      ...prev,
      {
        serviceRemark: defaultRemark,
        serviceType: defaultServiceType,
        destination: '',
        urgent: false,
        id: getUUID(),
      },
    ]);
  };

  return (
    <>
      {serviceList?.map((item, index) => (
        <Box
          border="1px solid #538FFF"
          borderRadius="0.625rem"
          bgcolor={!item.serviceType && !defaultType ? '#f5f5f5' : '#F5FAFF'}
          mt="1.88rem"
          p="1.25rem 1.88rem"
          key={item.id}
        >
          <Box display="flex" justifyContent="space-between">
            <Text fontSize="1.25rem" color="#2E4469" fontFamily="NotoSans-Bold" mb="1rem">
              Service Order {index + 1}
            </Text>
            {serviceList?.length > 1 && (
              <StyleButton
                Icon={DeleteIcon}
                width="2.25rem"
                height="2.25rem"
                borderRadius="0.5rem"
                onClick={handleDeleteOrderService(item.id)}
              />
            )}
          </Box>
          <Box display="flex" flexDirection="column" gridGap="0.75rem">
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Text fontSize="0.875rem" color="#666666">
                Order Service Type
                {defaultType && (
                  <span
                    style={{
                      fontSize: '1rem',
                      color: '#FF0300',
                    }}
                  >
                    *
                  </span>
                )}
              </Text>
              <FormControlLabel
                control={<Checkbox />}
                label={renderUrgentLabel()}
                checked={item.urgent}
                onChange={(e) => {
                  handleUpdateOrderService('urgent', item.id)(e.target.checked);
                }}
                className={classes.checkBox}
              />
            </Box>
            <AutoCompleteSelect
              placeholder="Select Order Service Type"
              value={item.serviceType}
              onChange={handleUpdateOrderService('serviceType', item.id)}
              itemList={typeOption}
              renderOption={renderServiceTypeOption}
              getOptionLabel={(option) => {
                return `${option.serviceTypeDesc ? `${option.serviceTypeDesc} - ` : ''}${option.text}`;
              }}
            />
          </Box>
          <Box display="flex" flexDirection="column" gridGap="0.75rem" mt="1.5rem">
            <Text fontSize="0.875rem" color="#666666">
              Destination
            </Text>
            <AutoCompleteInput
              placeholder="Select Destination"
              value={item.destination}
              onChange={handleUpdateOrderService('destination', item.id)}
              itemList={destinationList}
            />
          </Box>
          <Box display="flex" flexDirection="column" gridGap="0.75rem" mt="1.5rem">
            <Box display="flex" justifyContent="space-between">
              <Text fontSize="0.875rem" color="#666666">
                {`Service Remark (${remarkLimit} words limit)`}
              </Text>
              <AddRemarks list={serviceRemarkList} handleSelect={handleAddRemark(item.id)} />
            </Box>
            <StyleInput
              className={classes.remarkInput}
              placeholder="Service Remark"
              value={item.serviceRemark}
              onChange={handleUpdateOrderService('serviceRemark', item.id)}
              inputProps={{ maxLength: remarkLimit }}
              style={{ backgroundColor: !item.serviceType && !defaultType ? '#f5f5f5' : '#FFF' }}
              multiline
            />
          </Box>
        </Box>
      ))}
      <Box display="flex" justifyContent="left">
        <ButtonBase
          style={{ color: '#538FFF', gap: '0.7rem', fontSize: '1rem', fontWeight: 'bold', marginTop: '1.25rem' }}
          onClick={handleAddOrderService}
        >
          <AddIcon />
          Add Service
        </ButtonBase>
      </Box>
    </>
  );
};

const useStyles = makeStyles(() => ({
  remarkInput: {
    height: '6.5rem',
    padding: '1.25rem',
    alignItems: 'flex-start',
    overflow: 'auto',
  },
  icon: {
    width: '1.25rem',
    height: '1.25rem',
    marginRight: '0.5rem',
  },
  serviceTypeDesc: {
    color: '#3B86FF',
  },
  checkBox: {
    '&.MuiFormControlLabel-root': {
      marginRight: '0rem',
    },
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
      padding: '0 9px 0 0',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
  urgentLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.45rem',
  },
  triangleIcon: {
    fontSize: '1.5rem',
    color: 'rgba(215, 65, 37)',
  },
  triangleText: {
    fontSize: '0.75rem',
    color: '#FFF',
    fontFamily: 'NotoSans-Bold',
    position: 'absolute',
    top: '65%',
    left: '51%',
    transform: 'translate(-50%, -50%)',
    whiteSpace: 'nowrap',
    lineHeight: '1.25rem',
  },
}));

export default AddServiceOrders;
